export const config = {
  platesData: [
    ['circle', 'cross'],
    ['1', '2', '3', '4', '5'],
    ['a', 'b', 'c'],
    ['yes', 'no'],
    ['good', 'bad']
  ],
  publicPath: '.',
  shareLinks: {
    twitter: 'http://twitter.com/share?url=https%3A%2F%2Fanswq.com%2F&text=%E3%82%AA%E3%83%B3%E3%83%A9%E3%82%A4%E3%83%B3%E3%82%A4%E3%83%99%E3%83%B3%E3%83%88%E7%94%A8%E3%82%A2%E3%83%B3%E3%82%B5%E3%83%BC%E3%83%91%E3%83%8D%E3%83%AB%E3%80%8E%E3%82%A2%E3%83%B3%E3%82%B5%E3%83%BCQ%E3%80%8F&via=answq',
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fanswq.com%2F',
  }
}
